export default __webpack_public_path__ + "static/media/roxasCity.203899f1.jpg";